import { Container, styled } from "@mui/material";

import Dialog from "@mui/material/Dialog";
import Header from "./Component/Header";

function AlertModal({
  open,
  onClose,
  variant,
  children,
  allowClickAway = true,
}) {
  return (
    <DialogStyle
      open={open}
      keepMounted
      maxWidth="xs"
      onClose={allowClickAway ? onClose : () => {}}
      aria-describedby="alert-dialog-slide-description"
    >
      <Header variant={variant} />

      <DialogContainer>{children}</DialogContainer>
    </DialogStyle>
  );
}

const DialogStyle = styled(Dialog)(({ theme }) => ({
  zIndex: "999999",

  ".MuiPaper-root": {
    borderRadius: "8px",
    overflow: "initial",
    width: "100% ",
  },
}));

const DialogContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(6, 2, 2),
}));

export default AlertModal;
